import type { PillsState, PillsVariant } from "barte-design-system";

import { ERatePlanHistoryStatus } from "@payfac/types";

export const RATE_PLAN_HISTORY_PAGE_SIZE = 10;

export const RATE_PLAN_HISTORY_STATUS_PILL_STATE: Record<
  keyof typeof ERatePlanHistoryStatus,
  PillsState
> = {
  [ERatePlanHistoryStatus.CURRENT]: "success",
  [ERatePlanHistoryStatus.PREVIOUS]: "default",
};

export const RATE_PLAN_HISTORY_STATUS_PILL_VARIANT: Record<
  keyof typeof ERatePlanHistoryStatus,
  PillsVariant
> = {
  [ERatePlanHistoryStatus.CURRENT]: "light",
  [ERatePlanHistoryStatus.PREVIOUS]: "light",
};

export const RATE_PLAN_HISTORY_STATUS_LABEL_KEY: Record<
  keyof typeof ERatePlanHistoryStatus,
  string
> = {
  [ERatePlanHistoryStatus.CURRENT]: "payfac.pageRatePlanHistoryStatusCurrent",
  [ERatePlanHistoryStatus.PREVIOUS]: "payfac.pageRatePlanHistoryStatusPrevious",
};
